// extracted by mini-css-extract-plugin
export default {"cardRoot":"player-card_cardRoot__uSRiS","selectedCardRoot":"player-card_selectedCardRoot__AtJgr"};